export const moduleId: 'private-cameras' = 'private-cameras';
// tslint:disable-next-line
export default moduleId;
